import React from 'react';
import { useProgress } from '../../../../queries/ats/me/hooks';
import { PlayableTitle } from '../../../../queries/ats/titles/types/title';
import { ProgressBar } from '../../Progress/ProgressBar';
import css from './ats-title-progress.module.scss';

interface AtsTitleProgressProps {
  title: PlayableTitle;
}

export function AtsTitleProgress({ title }: AtsTitleProgressProps) {
  const progress = useProgress(title);

  if (progress !== undefined && inRange(progress, 3, 97)) {
    return <ProgressBar className={css.progressBar} value={progress} />;
  }

  return null;
}

function inRange(value: number, min: number, max: number) {
  return value >= min && value <= max;
}
